const main = document.querySelector('.main');

export function scrollTo(selector, offset) {
  let target = document.querySelector(selector);
  let top = target.getBoundingClientRect().top + main.scrollTop;

  let scrollData = {
    top: top - offset,
    behavior: 'smooth'
  }

  if (main instanceof HTMLBodyElement) {
    window.scrollTo(scrollData);
  } else {
    main.scrollTo(scrollData);
  }  
}

export function scrollToTop() {
  let scrollData = {
    top: 0,
    behavior: 'smooth'
  }

  if (main instanceof HTMLBodyElement) {
    window.scrollTo(scrollData);
  } else {
    main.scrollTo(scrollData);
  }
}

export function scrollToBottom() {
  let scrollData = {
    top: main.scrollHeight,
    behavior: 'smooth'
  }

  if (main instanceof HTMLBodyElement) {
    window.scrollTo(scrollData);
  } else {
    main.scrollTo(scrollData);
  } 

 
}